"use client";
import SvgEventNoteFilled from "./event_note-filled.svg.js";
import SvgEventNoteOutlined from "./event_note-outlined.svg.js";
import SvgEventNoteRound from "./event_note-round.svg.js";
import SvgEventNoteSharp from "./event_note-sharp.svg.js";
import SvgLiveTvFilled from "./live_tv-filled.svg.js";
import SvgLiveTvOutlined from "./live_tv-outlined.svg.js";
import SvgLiveTvRound from "./live_tv-round.svg.js";
import SvgLiveTvSharp from "./live_tv-sharp.svg.js";
import SvgWifiFilled from "./wifi-filled.svg.js";
import SvgWifiOutlined from "./wifi-outlined.svg.js";
import SvgWifiRound from "./wifi-round.svg.js";
import SvgWifiSharp from "./wifi-sharp.svg.js";
const event_note = {
  filled: SvgEventNoteFilled,
  outlined: SvgEventNoteOutlined,
  round: SvgEventNoteRound,
  sharp: SvgEventNoteSharp
};
const live_tv = {
  filled: SvgLiveTvFilled,
  outlined: SvgLiveTvOutlined,
  round: SvgLiveTvRound,
  sharp: SvgLiveTvSharp
};
const wifi = {
  filled: SvgWifiFilled,
  outlined: SvgWifiOutlined,
  round: SvgWifiRound,
  sharp: SvgWifiSharp
};
export {
  event_note,
  live_tv,
  wifi
};
